RivalIQ.module('suggestion.views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.InvalidHandle = Marionette.ItemView.extend({
        template: '#suggestionModalInvalidHandle'
    });

});
